import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "count", "btn"]
  static values = { liked: Boolean, likesCount: Number, url: String }

  toggle(event) {
    event.preventDefault()

    this.likedValue = !this.likedValue
    this.likesCountValue += this.likedValue ? 1 : -1
    this._render()

    const method = this.likedValue ? "POST" : "DELETE"
    fetch(this.urlValue, {
      method,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })
  }

  _render() {
    this.iconTarget.textContent = this.likedValue
      ? this.iconTarget.dataset.likedText
      : this.iconTarget.dataset.likeText

    if (this.hasBtnTarget) {
      this.btnTarget.classList.toggle("modal-comment__action-btn--liked", this.likedValue)
    } else {
      this.element.classList.toggle("comment__action--liked", this.likedValue)
    }

    this.countTarget.textContent = this.likesCountValue > 0 ? this.likesCountValue : ""
  }
}
